import React, { FC } from 'react';

import { Box, BoxProps } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

interface Props extends BoxProps {
  onClick();
  children: React.ReactNode | React.ReactNode[];
}

export const ReferenceWrapper: FC<Props> = props => {
  const { children, onClick, ...rest } = props;
  return (
    <Box
      px={3}
      pt={1.5}
      borderRadius={6}
      bg={colorOpacity(customTheme.colors.gray['200'], 0.1)}
      cursor="pointer"
      onClick={onClick}
      justifyContent="fex-start"
      w={60}
      h={20}
      _hover={{ bg: colorOpacity(customTheme.colors.primary, 0.1) }}
      {...rest}
    >
      {children}
    </Box>
  );
};
